<template>
	<!-- Repeating these classes for every button can be painful -->
	<button class="font-semibold rounded-lg shadow-lg">
		<slot></slot>
	</button>
</template>
